// extracted by mini-css-extract-plugin
module.exports = {"svgWrap":"UpBtnNews_svgWrap__Xt6Gx"};